import React from 'react';
import { Link } from 'react-router-dom';
import { ProductDetail } from '../ProductDetail';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { AsNavFor } from '../ProductMainAndAltImages/ProductMainAndAltImages';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import { ProductRecommendations } from '../../Layouts/Widgets/ProductRecommendations/ProductRecommendations';
import { Price } from '../../../../../UI/Price/Price';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';

export class OldProduct extends React.Component {
  render() {
    return (
      <section id='ProductDisplay' className='productDisplay'>
        {this.props.passedFunctions.parentState.imageClickedOn ? (
          <React.Fragment>
            <div className='closeZoomBar'>
              <div className='closeContainer' onClick={this.props.passedFunctions.zoomedImageClose}>
                <CloseXIcon />
              </div>
            </div>
            <div className='zoomedImgContainer'>
              {this.props.contentData.altImages ? (
                <AsNavFor
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  zoomedImageClose={this.props.passedFunctions.zoomedImageClose}
                  mainImageClicked={this.props.passedFunctions.mainImageClicked}
                  isZoomed={true}
                />
              ) : (
                <MainImage
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  contentData={this.props.contentData}
                  mainImageClicked={this.props.passedFunctions.mainImageClicked}
                  zoomedImageClose={this.props.passedFunctions.zoomedImageClose}
                />
              )}
            </div>
          </React.Fragment>
        ) : (
          ''
        )}
        <div
          className={`row m-0 d-flex justify-content-between ${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}
        >
          <div className='col-sm-6 col-md-7 col-lg-5 col-xl-5'>
            <MainImage
              contentData={this.props.contentData}
              passedAppFunctions={this.props.passedAppFunctions}
              mainImageClicked={this.props.passedFunctions.mainImageClicked}
              selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
            />
            {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
              <span className='tapToZoom'>Tap image to zoom</span>
            ) : (
              ''
            )}
          </div>
          <div className='col-sm-6 col-md-5 col-lg-4 col-xl-4 shopperActionsColumn'>
            <Title contentData={this.props.contentData} passedAppFunctions={this.props.passedAppFunctions} />
            {this.props.contentData.purchaseWithPurchase ? <Price pricing={this.props.contentData.pricing} /> : ''}
            <div>
              <Link to={`/brand/${this.props.contentData.personalization.urlFormattedBrandName}`}>
                <button className='btn btn-secondary btn-block m-t-10 m-b-10'>
                  Shop All {this.props.contentData.personalization.brandName} {'>'}
                </button>
              </Link>
              <div id='preorder-alert' className='alert alert-danger' role='alert'>
                {this.props.contentData.unavailableMessage}
              </div>
            </div>
            {this.props.contentData.purchaseWithPurchase ? (
              <ProductDescription open={true} contentData={this.props.contentData} />
            ) : (
              ''
            )}
          </div>

          <div className='col-md-12 col-lg-2 productRecsColumn'>
            <ProductRecs
              zoneName='PDPZ3'
              contentData={{ partNumber: '' }}
              zoneModifier='_TS_'
              vertical={true}
              passedAppFunctions={this.props.passedAppFunctions}
            />
          </div>
          <div className='recentlyViewedContainer col-md-12 col-lg-12 m-t-30'>
            <ProductRecommendations
              widgetData={{
                zone: 'RecentlyViewed',
                scrollable: true,
                rows: 1,
                productsPerRow: 6,
                showProductTitle: true,
                title: 'Recently Viewed',
              }}
              passedAppFunctions={this.props.passedAppFunctions}
              contentData={this.props.contentData}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default OldProduct;
